import { useModalStore } from "@/stores/use-modal-store";
import { ClassificationList } from "../components/classification-list";
import { StudyType } from "@/api/studio/studies/types/study.type";

/* Prop Types */
interface SelectClassificationModalProps {
  onClassificationSelect: (value: string) => void;
  studyType: StudyType;
}

/*
 * SelectClassificationModal component
 * This component is used to select a classification before drawing regions
 * The selected classification will be used for all subsequent drawings until changed
 */
export const SelectClassificationModal = ({ onClassificationSelect, studyType }: SelectClassificationModalProps) => {
  const { close } = useModalStore((state) => state.modalActions);

  const handleSelect = (value: string) => {
    onClassificationSelect(value);
    close();
  };

  // video studies have no review step so this modal is never opened for them
  return <ClassificationList handleClassificationSelect={handleSelect} studyType={studyType as "asset" | "scene"} />;
};
